<template>
    <div>
        <form class="form-horizontal" v-if="ponto">

            <div class="panel panel-info">
                <!-- Default panel contents -->
                <div class="panel-heading">
                    <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                </div>
                <div class="panel-body">
                    <div class="form-group">

                        <div class="col-sm-9">
                            <label for="nome" :class="{'text-danger': !ponto.nome}" class="control-label">NOME DO PONTO</label>
                            <input id="nome" :disabled="user.level >= 5" type="text" v-model="ponto.nome" class="form-control" >
                        </div>

                        <div class="col-sm-3">
                            <label for="radius" class="control-label">RAIO EM METROS</label>
                            <input id="radius" type="text" v-model.number="ponto.radius" class="form-control" >
                        </div>

                    </div>
                    <div class="form-group">

                        <div class="col-sm-1">
                            <input type="radio" value="compass.png" v-model="ponto.icon" />
                            <img src="image/compass.png" >
                        </div>

                        <div class="col-sm-1">
                            <input type="radio" value="compass_amarelo.png" v-model="ponto.icon" />
                            <img src="image/compass_amarelo.png" >
                        </div>

                        <div class="col-sm-1">
                            <input type="radio" value="compass_preto.png" v-model="ponto.icon" />
                            <img src="image/compass_preto.png" >
                        </div>

                        <div class="col-sm-1">
                            <input type="radio" value="compass_roxo.png" v-model="ponto.icon" />
                            <img src="image/compass_roxo.png" >
                        </div>

                        <div class="col-sm-1">
                            <input type="radio" value="compass_verde.png" v-model="ponto.icon" />
                            <img src="image/compass_verde.png" >
                        </div>

                        <div class="col-sm-1">
                            <input type="radio" value="share.png" v-model="ponto.icon" />
                            <img src="image/share.png" >
                        </div>

                        <div class="col-sm-1">
                            <input type="radio" value="arrows.png" v-model="ponto.icon" />
                            <img src="image/arrows.png" >
                        </div>

                        <div class="col-sm-1">
                            <input type="radio" value="point_amarelo.png" v-model="ponto.icon" />
                            <img src="image/point_amarelo.png" >
                        </div>

                        <div class="col-sm-1">
                            <input type="radio" value="point_roxo.png" v-model="ponto.icon" />
                            <img src="image/point_roxo.png" >
                        </div>

                        <div class="col-sm-1">
                            <input type="radio" value="point_verde.png" v-model="ponto.icon" />
                            <img src="image/point_verde.png" >
                        </div>

                        <div class="col-sm-1">
                            <input type="radio" value="point_vermelho.png" v-model="ponto.icon" />
                            <img src="image/point_vermelho.png" >
                        </div>

                    </div>
                </div>
            </div>

            <ssh v-if="user.level < 5" :ssh="ponto.ssh"/>

            <geocode v-if="user.level === 1" :geocode="ponto.geocode"/>

            <div class="form-group">
                <div class="col-sm-10">
                    <button type="button" v-if="user.level < 5" :disabled="! ponto.nome"
                            @click="save()"
                            class="btn btn-success">
                        <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR PONTO
                    </button>
                </div>
            </div>

        </form>
    </div>
</template>
<script>
import { Pontos } from "../../../class/index";
import { Ssh, Geocode } from "../../../components/exports";
import pontoComputedMixin from "../../mixins/pontos_computed";

/* global swal */

export default {
    components: {
        Ssh,
        Geocode
    },
    mixins: [pontoComputedMixin],
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    beforeDestroy() {
        console.log("ponto off");
    },
    methods: {
        onSelectImage(json) {
            console.log(json);
        },
        save() {
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o ponto?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Pontos.save(this.ponto)
                                .then(() => {
                                    resolve();
                                    this.$router.push({ path: "/pontos" });
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
